import { fromJS, Map, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export enum BannerUrgenciesEnum {
  standard = 'standard',
  urgent = 'urgent',
}

export const BANNER_SCHEMA = Object.freeze({
  CTA: '',
  DISMISSIBLE: false,
  LEVEL: 0,
  MESSAGE: '',
  NAME: '',
  URGENCY: '',
  TYPE: '',
  TRACKING: Map({}),
});
const RECORD = generateSchema(BANNER_SCHEMA);
const KEYS: any = generateKeys(BANNER_SCHEMA);

export class Banner extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get cta(): string {
    return this.get(KEYS.CTA);
  }

  get dismissible(): boolean {
    return this.get(KEYS.DISMISSIBLE);
  }

  get level(): number {
    return this.get(KEYS.LEVEL);
  }

  get message(): string {
    return this.get(KEYS.MESSAGE);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get urgency(): string {
    return this.get(KEYS.URGENCY);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get tracking(): Map<string, any> {
    return this.get(KEYS.TRACKING) || Map({});
  }

  isStandard(): boolean {
    return this.urgency === BannerUrgenciesEnum.standard;
  }

  isUrgent(): boolean {
    return this.urgency === BannerUrgenciesEnum.urgent;
  }
}
